import { defineQuartzConfig } from 'quartz-config';
export default defineQuartzConfig({
  type: 'application',
  auth: 'none',
  historyBasename: ['/payments', '/hs/payments'],
  htmlTitle: 'Checkout',
  additionalDlbs: ['apollo-dlb/bundle.js'],
  includeDefaultViewportMetaTag: true,
  initialPageLoadTracking: true,
  sessionResourceTracking: true,
  logFetchErrors: {
    options: {
      ignoreErrors: [/Loading chunk .* failed./i, /Loadable: error loading split chunk/i, /dlb .*bundle.production.js not loaded/i]
    }
  }
});